/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of SequencedEvent
 */

import { IContext } from 'com/didichuxing/context/IContext';
import { IObjectMap } from 'com/didichuxing/IObjectMap';
import { IAttrs } from 'com/didichuxing/tracker/IAttrs';
import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { ITrackedEventData } from 'com/didichuxing/tracker/event/ITrackedEventData';
import { EventStatus } from 'com/didichuxing/tracker/plugin/events/EventStatus';
import AEvent from 'com/didichuxing/tracker/plugin/events/AEvent';

export default abstract class SequencedEvent extends AEvent {

    /**
     * Omega事件全局序列名称前缀。
     * @type {string}
     */
    public static readonly OMG_SEQUENCE_NAME_PREFIX: string = '__OMG_SEQUENCE_';

    /**
     * Omega事件全局序列名称后缀。
     * @type {string}
     */
    public static readonly OMG_SEQUENCE_NAME_SUFFIX: string = '__';

    /**
     * 事件的序列号。
     * 默认为-1，表示没有序列号。
     */
    private readonly sequence: number;

    /**
     * @constructor
     * @param {IAttrs} attrs
     * @param {IContext} context
     * @param {IAttrs} info 事件生成的时候默认的一些属性信息
     */
    constructor(attrs: IAttrs, context: IContext, info?: IAttrs) {
        super(attrs, context, info);
        const prefix: string = SequencedEvent.OMG_SEQUENCE_NAME_PREFIX;
        const suffix: string = SequencedEvent.OMG_SEQUENCE_NAME_SUFFIX;
        if (!(window as any)[`${ prefix }${ (context as ITrackerContext).viewportId }${ suffix }`]) {
            (window as any)[`${ prefix }${ (context as ITrackerContext).viewportId }${ suffix }`] = 0;
        }
        this.sequence = (window as any)[`${ prefix }${ (context as ITrackerContext).viewportId }${ suffix }`]++;
    }

    /**
     * @override
     * @inheritDoc
     * @returns {ITrackedEventData}
     */
    public getData(): ITrackedEventData {
        return {
            ...super.getData(),
            sequence: this.sequence
        };
    }

    /**
     * @override
     * @inheritDoc
     * @returns {IObjectMap<string>}
     */
    protected getDataKeyMap(): IObjectMap<string> {
        return {
            ...super.getDataKeyMap(),
            sequence: 'seq'
        };
    }

    /**
     * @override
     * @inheritDoc
     * @returns {EventStatus}
     */
    public get status(): EventStatus {
        return EventStatus.NORMAL;
    }
}
